<ng-container *ngIf="cardsLoaded$ | async as loaded; else loading">
    <ng-container *ngIf="cards$ | async as cards">
        <ng-container *ngIf="cards?.length > 0; else empty">
            <div *ngFor="let card of cards">
                <rwidget-cards-list-item [card]="card"></rwidget-cards-list-item>
            </div>
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #loading>
    <ridango-ui-skeleton-loader
        class="w-full"
        [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate"
        height="6rem"
        count="10"></ridango-ui-skeleton-loader>
</ng-template>

<ng-template #empty>
    <div class="mx-4 mb-3 flex flex-col items-center md:m-0">
        <div class="relative mb-3 w-full sm:w-4/6 md:hidden">
            <p class="absolute left-0 right-0 mx-4 my-6 text-center text-xl font-bold italic text-green-700">
                {{ 'CARDS_LIST_FILLER_IMAGE_TEXT' | translate }}
            </p>
            <img class="w-full rounded-2xl" alt="" src="{{ assetsPath$ | async }}/img/cards/space-filler-logo.jpg" />
        </div>
        <div class="w-full">
            <div class="flex items-center rounded-lg bg-[#F0F0F0] p-3 dark:bg-contrast-black">
                <ridango-ui-icons
                    class="mr-4 h-[1.5rem] min-h-[1.5rem] w-[1.5rem] min-w-[1.5rem] fill-[#0C1C34] dark:fill-contrast-yellow"
                    name="infoCircle"></ridango-ui-icons>
                <div class="leading-5 text-[#0C1C34] dark:text-contrast-yellow">
                    {{ 'ADD_CARD_TO_SEE_TICKETS_AND_BALANCE' | translate }}
                </div>
            </div>
        </div>
    </div>
</ng-template>
